export default __webpack_public_path__ + "static/media/11.a10ac294.jpg";